import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectSavingsStaff } from "../Model/ProposalProjectSavingsStaff";

export async function createProposalProjectSavingsStaff(data) {
	let response = await getAPIResponse("/v1/proposal-project-staff/add", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProjectSavingsStaff = [];
	response.forEach((responseData) => {
		proposalProjectSavingsStaff.push(ProposalProjectSavingsStaff.createFromResponseData(responseData));
	});
	return proposalProjectSavingsStaff;
}